import lottie from 'lottie-web'
import Cookies from 'js-cookie'

(function() {
    // if the cookie is set, don't display the animation
    // but instead display the final state SVG logo
    const cookieName = 'hover_no_anim'
    const cookie = Cookies.get(cookieName)
    const gatedCookie = Cookies.get('hover_remember')
    const target = document.querySelector('.home__logo')

    if (!target) {
        return false
    }

    if (cookie) {
        target.classList.add('home__logo--show')
        return false
    } else {
        // only set the no animation cookie if the user has already
        // navigated away from the Age Gate page
        if (!!gatedCookie) {
            Cookies.set(cookieName, true);
        }
    }

    lottie.loadAnimation({
        container: target,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path:  HOVER.template_directory_uri + '/hover.json'
    });
})()
